<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'material',
})
</script>
<template>
  <div>
    <a-card>
      <div class="material-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="模板名称">
                <a-input v-model:value="state.tableData.param.materialName" placeholder="请输入模板名称" :maxlength="100"
                  allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="店铺类型">
                <a-select v-model:value="state.tableData.param.storeTypeCode" placeholder="请选择店铺类型" allow-clear>
                  <a-select-option v-for="item in storeTypeList" :key="item.code" :value="item.code">{{ item.name
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="分类">
                <a-select v-model:value="state.tableData.param.categoryCode" placeholder="请选择分类" allow-clear>
                  <a-select-option v-for="item in categoryList" :key="item.code" :value="item.code">{{ item.name
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action flex flex-nowrap">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary">
                  <SearchOutlined />查询
                </ant-button>
                <ant-button class="resetFun" @click="resetFun" type="primary">
                  <RedoOutlined />重置
                </ant-button>
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action flex flex-nowrap justify-start md:justify-end">
                <ant-button class="resetFun mr-[10px]!" @click="sortDialogRef?.openDialog()" type="primary"
                  v-auth="'material.sort'">
                  <SwapOutlined />小程序展示排序
                </ant-button>
                <ant-button class="add" @click="openDialog('add', {})" type="primary" v-auth="'material.add'">
                  <PlusOutlined />新增模板
                </ant-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- <div>
        <a-radio-group v-model:value="downloadMode" class="ml10" option-type="button" size="small">
          <a-radio value="single">逐个下载</a-radio>
          <a-radio value="backendZip">后端打包</a-radio>
          <a-radio value="frontendZip">前端打包</a-radio>
        </a-radio-group>
      </div> -->
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading"
        :pagination="false" row-key="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'fileSizeStr'">
            {{ record.fileSizeStr || formatFileSize(record.fileSize) }}
          </template>
          <template v-else-if="column.key === 'fileUrls'">
            <div class="table-action-left">
              <a-button v-if="record.fileUrls && record.fileUrls.length > 0" type="link" size="small"
                @click="onDownload(record)">
                <DownloadOutlined />下载
              </a-button>
              <span v-else>--</span>
            </div>
          </template>
          <template v-else-if="column.key === 'action'">
            <div class="table-action-left">
              <a-button type="link" size="small" @click="openDialog('detail', record)">查看</a-button>
              <a-button type="link" size="small" @click="openDialog('edit', record)"
                v-auth="'material.edit'">编辑</a-button>
              <a-button type="link" size="small" danger @click="onDelete(record)" v-auth="'material.del'">删除</a-button>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination v-model:current="state.tableData.param.pageNum" v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total" :page-size-options="['10', '20']" show-size-changer
        :show-total="(total) => `共 ${total} 条`" :showQuickJumper="true" @change="onPageChange"
        @show-size-change="onShowSizeChange" />
    </a-card>
    <MaterialDialog ref="dialogRef" :store-type-list="storeTypeList" :category-list="categoryList"
      @create-update="createUpdate" />
    <SortDialog ref="sortDialogRef" :category-list="categoryList" @refresh="getTableData" />
  </div>
</template>

<script setup lang="ts" name="material">
import { reactive, ref, onMounted, h } from 'vue'
import { message, Modal } from 'ant-design-vue'
import { SearchOutlined, RedoOutlined, PlusOutlined, DownloadOutlined, ExclamationCircleOutlined, SwapOutlined } from '@ant-design/icons-vue'
import { useMaterial } from '@/store/material/material'
import { useDictionary } from '@/store/system/dictionary'
import { fetchWithPaginationFallback, type FallbackType } from '@/utils/paginationFallback'
import MaterialDialog from './dialog.vue'
import SortDialog from './sortDialog.vue'

const materialStore = useMaterial()
const dictionaryStore = useDictionary()
const dialogRef = ref()
const sortDialogRef = ref()

const columns = [
  { title: '序号', key: 'index', width: 80, customRender: ({ index }: { index: number }) => index + 1 },
  { title: '店铺类型', dataIndex: 'storeTypeStr', key: 'storeTypeStr', ellipsis: true },
  { title: '分类', dataIndex: 'categoryStr', key: 'categoryStr', ellipsis: true },
  { title: '模板名称', dataIndex: 'materialName', key: 'materialName', ellipsis: true },
  { title: '文件大小', key: 'fileSizeStr', width: 100 },
  { title: '转发次数', dataIndex: 'downloadCount', key: 'downloadCount', width: 100 },
  { title: '邮件次数', dataIndex: 'emailCount', key: 'emailCount', width: 100 },
  // { title: '附件', key: 'fileUrls', width: 100 },
  { title: '上传时间', dataIndex: 'createTime', key: 'createTime', minWidth: 260, ellipsis: true },
  { title: '操作', key: 'action', width: 200 }
]

const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      materialName: '',
      storeTypeCode: undefined as string | undefined,
      categoryCode: undefined as string | undefined
    }
  }
})

const storeTypeList = ref<any[]>([])
const categoryList = ref<any[]>([])
const downloadMode = ref<'single' | 'backendZip' | 'frontendZip'>('single')

const getCategoryList = async () => {
  try {
    const data: any = await dictionaryStore.getDict({ code: 'material_category' })
    categoryList.value = data || []
    return data || []
  } catch (err) {
    console.error('获取分类字典失败', err)
    categoryList.value = []
    return []
  }
}

const resetFun = () => {
  state.tableData.param.materialName = ''
  state.tableData.param.storeTypeCode = undefined
  state.tableData.param.categoryCode = undefined
  state.tableData.param.pageNum = 1
}

// 分页越界兜底类型：'none' 留在当前空页 | 'first' 回到第一页 | 'prev' 回到上一页
const pageFallbackType: FallbackType = 'prev'

const getTableData = async () => {
  state.tableData.loading = true
  try {
    const data: any = await fetchWithPaginationFallback(
      (param) => materialStore.getMaterialPage(param),
      state.tableData.param,
      pageFallbackType
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    setTimeout(() => {
      state.tableData.loading = false
    }, 500)
  }
}

const openDialog = (type: string, row: any) => {
  if (type === 'add') {
    dialogRef.value.openDialog(type, row)
  } else {
    materialStore.getMaterialInfo(row.id).then((data: any) => {
      dialogRef.value.openDialog(type, data)
    })
  }
}

const onDelete = (row: any) => {
  Modal.confirm({
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    transitionName: '',
    content: `此操作将永久删除资料："${row.materialName}"，是否继续?`,
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      return materialStore.deleteMaterial(row.id).then(() => {
        message.success('删除成功')
        getTableData()
      })
    }
  })
}

const onDownload = async (row: any) => {
  if (!row.fileUrls || row.fileUrls.length === 0) return
  materialStore.downloadMaterial(row.id).catch(() => { })
  if (downloadMode.value === 'backendZip') {
    try {
      const res: any = await materialStore.zipDownloadMaterial(row.id)
      const blob = new Blob([res], { type: 'application/zip' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${row.materialName || '资料'}.zip`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    } catch {
      message.error('后端打包下载失败')
    }
  } else if (downloadMode.value === 'frontendZip') {
    try {
      const JSZip = (await import('jszip')).default
      const zip = new JSZip()
      const promises = row.fileUrls.map(async (url: string, i: number) => {
        const res: any = await materialStore.proxyDownload(url)
        const name = url.split('/').pop() || `file_${i}`
        zip.file(name, res)
      })
      await Promise.all(promises)
      const zipBlob = await zip.generateAsync({ type: 'blob' })
      const downloadUrl = window.URL.createObjectURL(zipBlob)
      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = `${row.materialName || '资料'}.zip`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(downloadUrl)
    } catch (e) {
      console.error(e)
      message.error('前端打包下载失败')
    }
  } else {
    row.fileUrls.forEach((url: string, i: number) => {
      setTimeout(() => {
        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.src = url
        document.body.appendChild(iframe)
        setTimeout(() => document.body.removeChild(iframe), 5000)
      }, i * 300)
    })
  }
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

const createUpdate = () => {
  message.success('操作成功')
  getTableData()
  dialogRef.value.closeDialog()
}

const formatFileSize = (size?: number) => {
  if (!size) return '--'
  if (size < 1024) return size + ' B'
  if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB'
  if (size < 1024 * 1024 * 1024) return (size / 1024 / 1024).toFixed(2) + ' MB'
  return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
}

const getStoreTypeList = async () => {
  try {
    const data: any = await dictionaryStore.getDict({ code: 'store_type' })
    storeTypeList.value = data.filter(item => item.name === '新开店铺') || []
  } catch (err) {
    console.error('获取店铺类型失败', err)
    storeTypeList.value = []
  }
}

const init = async () => {
  await getStoreTypeList()
  getCategoryList()
  getTableData()
}

onMounted(() => {
  init()
})
</script>

<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt15 {
  margin-top: 15px;
}
</style>
